import type { Status } from '../types';

/** Global chrome strings (Arabic). Sector content lives in src/data/*. */
export const ar = {
  platformName: 'مرصد · منصة دعم القرار الوطني',
  platformTagline: 'نظام دعم القرار — مؤشرات الأداء الوطنية',
  updated: 'البيانات محدّثة —',
  adminNote: 'يتحكم المسؤول في اللغة والمظهر',
  langLabel: 'اللغة',
  themeLight: 'الوضع الفاتح',
  themeDark: 'الوضع الداكن',
  yearLabel: 'الفترة',
  stageLabel: 'القطاع الفرعي',
  loading: 'جارٍ التحميل…',
  loginTitle: 'تسجيل الدخول',
  loginSubtitle: 'منصّة دعم القرار الوطني — للاستخدام الرسمي المصرّح به',
  username: 'اسم المستخدم',
  password: 'كلمة المرور',
  signIn: 'دخول',
  signingIn: 'جارٍ التحقّق…',
  signOut: 'تسجيل الخروج',
  loginError: 'اسم المستخدم أو كلمة المرور غير صحيحة',
  loginNote: 'وصول مقيّد — جميع المحاولات قد تُسجّل.',
  deltaHint: 'التغيّر مقارنة بالفترة السابقة',
  whatItMeans: 'ما المقصود',
  betterHigh: 'الأعلى أفضل',
  betterLow: 'الأقل أفضل',
  betterNeutral: 'حسب السياق',
  recTitle: 'أفكار وخطوات مقترحة للتحسين',
  recHint: 'انقر لعرض خطوات التحسين المقترحة',
  close: 'إغلاق',
  navNational: 'الوطني',
  nationalTitle: 'النظرة الوطنية الشاملة',
  nationalSubtitle: 'ملخص تنفيذي عبر القطاعات لدعم القرار الاستراتيجي',
  readinessIndex: 'مؤشر الجاهزية الوطنية',
  targetsAtRisk: 'مؤشرات دون المستهدف',
  subdomains: 'المجالات الفرعية',
  viewDomain: 'عرض التفاصيل',
  navCommitments: 'الالتزامات',
  commitmentsTitle: 'الالتزامات والبرامج الوطنية',
  commitmentsSubtitle: 'متابعة تنفيذ البرامج الاستراتيجية عبر القطاعات',
  attentionTitle: 'يتطلب انتباهك',
  attentionEmpty: 'لا توجد بنود حرجة تتطلب الانتباه حالياً.',
  momentumUp: 'تحسّن عن الفترة السابقة',
  momentumDown: 'تراجع عن الفترة السابقة',
  momentumFlat: 'مستقر مقارنة بالفترة السابقة',
  delivery: 'نسبة الإنجاز',
  planned: 'المخطط',
  progStatus: { 'on-track': 'على المسار', 'at-risk': 'تحت المخاطرة', 'off-track': 'متعثّر' } as Record<import('../core/programs').ProgStatus, string>,
  programsLabel: 'البرامج',
  onTrackCount: 'على المسار',
  atRiskCount: 'تحت المخاطرة',
  offTrackCount: 'متعثّرة',
  milestonesLabel: 'المراحل الرئيسية',
  contributingKpis: 'المؤشرات المساهمة',
  sectorsTouched: 'القطاعات المشمولة',
  viewProgram: 'تفاصيل البرنامج',
  navMethodology: 'منهجية المؤشرات',
  methodologyTitle: 'منهجية المؤشرات ودليل الحساب',
  methodologySubtitle: 'تعريف كل مؤشر وطريقة احتسابه',
  searchPlaceholder: 'ابحث عن مؤشر أو تعريف أو معادلة…',
  noResults: 'لا توجد نتائج مطابقة',
  formulaLabel: 'طريقة الحساب',
  indicatorsBySector: 'مؤشرات القطاعات',
  unitLabel: 'الوحدة',
  resultsCount: 'نتيجة',
  reasonOverdue: 'تنبيه متأخر',
  reasonCritical: 'تنبيه حرج',
  reasonOffTarget: 'مؤشر بعيد عن المستهدف',
  reasonProgramRisk: 'برنامج متعثّر',
  overviewTitle: 'النظرة الوطنية الشاملة',
  overviewSubtitle: 'ملخص تنفيذي عبر القطاعات لدعم اتخاذ القرار',
  compositeLabel: 'المؤشر المركّب',
  criticalAlerts: 'تنبيهات حرجة',
  keyIndicators: 'أبرز المؤشرات',
  openDashboard: 'فتح اللوحة',
  printBriefing: 'طباعة الموجز',
  targetLabel: 'المستهدف',
  onTrack: 'تم تحقيق المستهدف',
  nearTarget: 'قريب من المستهدف',
  offTarget: 'بعيد عن المستهدف',
  ownerLabel: 'الجهة المسؤولة',
  dueLabel: 'الموعد المستهدف',
  overdue: 'متأخر',
  alertState: {
    open: 'مفتوح',
    'in-progress': 'قيد المعالجة',
    resolved: 'تمت المعالجة',
  } as Record<import('../types').AlertState, string>,
  errorTitle: 'تعذّر تحميل البيانات',
  errorBody: 'يرجى التحقق من الاتصال أو مصدر البيانات والمحاولة مرة أخرى.',
  status: {
    excellent: 'ممتاز',
    good: 'جيد',
    watch: 'متابعة',
    act: 'تدخّل',
  } as Record<Status, string>,
};

export type ChromeStrings = typeof ar;
